import React, { useState } from 'react'
import parse, { HTMLReactParserOptions, domToReact } from 'html-react-parser'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/livbrite/resources/constants'
import { Container } from './styled'
import { ContactForm } from 'app/livbrite/components/ContactForm'

export const FooterLinks = () => {
  const [openModal, setOpenModal] = useState(false)
  const staticBlockID = CMS_BLOCK.FOOTER_QUICK_LINKS
  const staticBlock = useCmsBlock({
    id: staticBlockID,
    isLazy: false
  })

  if (!staticBlock.content) return null

  const options: HTMLReactParserOptions = {
    replace: (domNode: any) => {
      const { attribs, children } = domNode

      if (!attribs) {
        return
      }

      if (attribs.class === 'contact-trigger') {
        return <span onClick={() => setOpenModal(true)} className='contact_trigger'>{domToReact(children, options)}</span>
      }
    }
  }

  return (
    <>
      <Container>
        {staticBlock.content && (
          <div>
            {parse(staticBlock.content, options)}
          </div>
        )}
      </Container>
      <ContactForm showForm={openModal} type='resident_contact' setShowForm={setOpenModal} />
    </>
  )
}
